import {ChatSourceInput} from 'llm/chat-library/ChatDAO';
import {ChatFileUpload} from 'llm/chat-library/ChatLibraryTypes';
import * as Net from 'util/Net';

import {CreateRoutinePayload, UpdateRoutinePayload} from './RoutineTypes';

export function createRoutine(payload: CreateRoutinePayload): Promise<{id: string}> {
  const {runAs} = payload;

  return Net.postJSONPromise({
    url: '/1/api/llm/routines',
    data: {
      name: payload.name,
      description: payload.description,
      messageBlocks: payload.messageBlocks,
      agentType: payload.agentType,
      triggerType: payload.triggerType,
      triggerConfig: payload.triggerConfig,
      allowedApprovalCategories: payload.allowedApprovalCategories,
      agentWorkspaceFolderId: payload.agentWorkspaceFolderId,
      memoryEnabled: payload.memoryEnabled,
      runAs,
      ...(payload.collaborations == null ? {} : {collaborations: payload.collaborations}),
    },
  });
}

export function updateRoutine(id: string, payload: UpdateRoutinePayload): Promise<{id: string}> {
  return Net.patchJSONPromise({
    url: `/1/api/llm/routines/${id}`,
    data: payload,
  });
}

export function pauseRoutine(id: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:pause`,
    data: {},
  });
}

export function resumeRoutine(id: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:resume`,
    data: {},
  });
}

export function runRoutine(id: string): Promise<{chatSessionId: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:run`,
    data: {},
  });
}

/**
 * Selections carried alongside a direct-message run, mirroring the chat composer's wire shapes so
 * the server builds them the same way as a normal chat message (see run_agent_directly). `sources`
 * comes from `getSources`; `fileBlocks` are completed uploads from `getCompletedUploads`.
 */
export interface RunAgentDirectlyOptions {
  sources?: Array<ChatSourceInput>;
  fileBlocks?: Array<ChatFileUpload>;
}

export function runAgentDirectly(
  id: string,
  message: string,
  {sources, fileBlocks}: RunAgentDirectlyOptions = {}
): Promise<{chatSessionId: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:run-with-message`,
    data: {message, sources, fileBlocks},
  });
}

export function archiveRoutine(id: string, reason: string): Promise<{id: string}> {
  return Net.postJSONPromise({
    url: `/1/api/llm/routines/${id}:archive`,
    data: {reason},
  });
}
